import {ProFormText, ProFormTextArea} from '@ant-design/pro-form';
import {FrontendSupportService} from '@common/api';
import {Button} from 'antd';
import {
  CommonManagerEdit,
  CommonManagerEditProps,
} from 'components/Common/Manager/Edit';
import {useAuthorize} from 'core/Authorize';
import {useApi} from 'hooks/useApi';

export const BackendSupportReply: React.FC<CommonManagerEditProps> = props => {
  const {user} = useAuthorize<any>();
  const update = useApi(FrontendSupportService.update, {
    successMessage: '回覆成功',
  });
  return (
    <CommonManagerEdit
      initialValues={props.data ?? {}}
      trigger={<Button>回覆問題</Button>}
      onFinish={async values => {
        await update({
          requestBody: {
            reply: values.reply,
            status: 'REPLY',
          },
          id: props.data!.id,
        });
      }}
      {...props}
    >
      <ProFormText label="回報人" name={['user', 'username']} readonly />
      <ProFormText label="聯絡信箱" name="email" readonly />
      <ProFormTextArea label="使用者回報內容" name="content" readonly />

      <ProFormTextArea
        label="管理員回覆內容"
        name="reply"
        required
        rules={[{required: true}]}
      />
    </CommonManagerEdit>
  );
};
